import { Users, MessageSquare, BarChart3, Star, Activity } from "lucide-react";

/* A realistic, code-built organiser dashboard mockup shown inside a browser chrome. */
export default function DashboardMockup({ className = "" }) {
  const activity = [
    { who: "Anonymous", what: "asked a question", when: "2m" },
    { who: "K. Mensah", what: "voted in a poll", when: "5m" },
    { who: "Anonymous", what: "rated a session 5★", when: "8m" },
    { who: "F. Al-Rashid", what: "asked a question", when: "12m" },
  ];
  const bars = [40, 62, 55, 78, 90, 72, 84];

  return (
    <div className={`rounded-xl border border-border bg-card shadow-sm overflow-hidden ${className}`}>
      {/* browser chrome */}
      <div className="flex items-center gap-2 px-4 h-10 border-b border-border bg-muted/50">
        <span className="h-2.5 w-2.5 rounded-full bg-destructive/60" />
        <span className="h-2.5 w-2.5 rounded-full bg-accent/60" />
        <span className="h-2.5 w-2.5 rounded-full bg-chart-3/60" />
        <div className="ml-3 flex-1">
          <div className="mx-auto h-5 w-56 rounded-md bg-background border border-border text-[10px] flex items-center justify-center text-muted-foreground">
            app.pitsoio.com/dashboard
          </div>
        </div>
      </div>

      <div className="p-5 sm:p-6">
        <div className="flex items-center justify-between mb-5">
          <div>
            <p className="text-xs uppercase tracking-[0.18em] text-muted-foreground font-semibold">Event overview</p>
            <h3 className="font-display text-lg font-bold text-foreground">Africa Tech Forum 2026</h3>
          </div>
          <span className="text-[11px] font-semibold px-2.5 py-1 rounded-full bg-accent/10 text-accent border border-accent/20">
            ● Live
          </span>
        </div>

        {/* stat cards */}
        <div className="grid grid-cols-4 gap-3 mb-5">
          {[
            { icon: Users, label: "Attendees", value: "342" },
            { icon: MessageSquare, label: "Questions", value: "58" },
            { icon: Activity, label: "Participation", value: "81%" },
            { icon: Star, label: "Feedback", value: "4.6" },
          ].map((s, i) => (
            <div key={i} className="rounded-lg border border-border bg-background p-3">
              <s.icon className="h-4 w-4 text-accent mb-2" />
              <div className="font-display text-xl font-bold text-foreground leading-none">{s.value}</div>
              <div className="text-[10px] text-muted-foreground mt-1">{s.label}</div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-5 gap-4">
          {/* chart */}
          <div className="col-span-3 rounded-lg border border-border bg-background p-4">
            <div className="flex items-center justify-between mb-3">
              <span className="text-xs font-semibold text-foreground flex items-center gap-1.5">
                <BarChart3 className="h-3.5 w-3.5 text-muted-foreground" /> Participation
              </span>
              <span className="text-[10px] text-muted-foreground">Last 7 sessions</span>
            </div>
            <div className="flex items-end gap-2 h-24">
              {bars.map((h, i) => (
                <div key={i} className="flex-1 rounded-t-sm bg-primary/80" style={{ height: `${h}%` }} />
              ))}
            </div>
          </div>

          {/* recent activity */}
          <div className="col-span-2 rounded-lg border border-border bg-background p-4">
            <span className="text-xs font-semibold text-foreground">Recent activity</span>
            <ul className="mt-3 space-y-2.5">
              {activity.map((a, i) => (
                <li key={i} className="flex items-start gap-2 text-[11px]">
                  <span className="mt-1 h-1.5 w-1.5 rounded-full bg-accent shrink-0" />
                  <span className="text-muted-foreground leading-snug">
                    <span className="text-foreground font-medium">{a.who}</span> {a.what} · {a.when}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
